import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSF Schedule API
 */
export const wsfScheduleApiMeta: ApiMeta = {
  name: "wsf-schedule",
  baseUrl: "https://www.wsdot.wa.gov/ferries/api/schedule/rest",
};
